export enum PrivateDataMaskType {
  default,
  digits,
  passport,
  phone,
  email,
}

interface MaskPrivateDataOptions {
  maskType?: PrivateDataMaskType;
  excludeStrings?: string[];
}

export const maskPrivateData = (
  value: string = '',
  {maskType = PrivateDataMaskType.default, excludeStrings = []}: MaskPrivateDataOptions = {},
) => {
  if (typeof value !== 'string') {
    value = '';
  }
  const mask = '*';
  const maskDigits = (v: string) => v.replace(/\d/g, mask).replace(new RegExp(`[^${mask}]{1}`, 'g'), ' ');
  const maskDefault = (v: string) => v.slice(0, 11).replace(/./g, mask);

  switch (maskType) {
    case PrivateDataMaskType.passport:
      if (excludeStrings.length) {
        const divider = excludeStrings[0];
        const dividerPosition = value.search(new RegExp(divider));
        if (dividerPosition > -1) {
          const before = value.slice(0, dividerPosition);
          const after = value.slice(dividerPosition + divider.length);
          return `${maskDigits(before)}${divider}${maskDefault(after)}`;
        } else return maskDefault(value);
      } else return maskDefault(value);

    case PrivateDataMaskType.digits:
      return maskDigits(value);

    case PrivateDataMaskType.phone:
      return Array.from(value)
        .map((letter, index) => {
          if (index > value.length - 9 && index < value.length - 3) {
            return letter.match(/\d/) ? mask : ' ';
          } else {
            return letter;
          }
        })
        .join('');

    case PrivateDataMaskType.email: {
      const arr = value.split('@');
      if (arr.length !== 2) {
        return '';
      }
      const nameStart = arr[0].slice(0, 1);
      const nameEnd = arr[0].slice(1).replace(/./g, '*').substring(0, 10);
      const tail = arr[1].split('.');
      const ext = tail.pop() ?? '';
      const domainFull = tail.join('');
      const domainStart = domainFull.slice(0, 1);
      const domainEnd = domainFull.slice(1).replace(/./g, '*').substring(0, 6);
      return `${nameStart}${nameEnd}@${domainStart}${domainEnd}.${ext}`;
    }

    default:
      return maskDefault(value);
  }
};
